import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { event } from 'react-ga';
import createSagaMiddleware from 'redux-saga';

import history from './history';
import rootSaga from './rootSaga';
import rootReducer from './rootReducer';

const sagaMiddleware = createSagaMiddleware();

export const googleAnalytics = (store) => (next) => (action) => {
  event({
    category: 'REDUX',
    action: action.type,
  });
  return next(action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => (
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.res', 'payload.rej'],
      },
    }).concat(routerMiddleware(history), googleAnalytics, sagaMiddleware)
  ),
  devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
